export default __webpack_public_path__ + "static/media/background-dark.73f4b08d.svg";